import { combineReducers } from "@reduxjs/toolkit";
import mainReducer from "./scenes/Main/main.slice";
import accountPayableReducer from "./scenes/AccountPayable/accountPayable.slice";
import accountReceivableReducer from "./scenes/AccountReceivable/accountReceivable.slice";

const rootReducer = combineReducers({
  main: mainReducer,
  accountReceivable: accountReceivableReducer,
  accountPayable: accountPayableReducer,
});

export default rootReducer;
